(function () {
    const searchInput = document.getElementById('hero-search-input');
    const searchResults = document.getElementById('hero-search-results');
    
    if (!searchInput || !searchResults) return;

    let postsCache = null;
    let isFetching = false;

    async function fetchPosts() {
        if (postsCache) return postsCache;
        if (isFetching) return null;
        
        isFetching = true;
        
        // Ghost injected script carries the data-api-key
        const scriptTag = document.querySelector('script[data-api-key]');
        const apiKey = scriptTag ? scriptTag.getAttribute('data-api-key') : null;
        
        if (!apiKey) {
            console.error('Ghost Content API Key not found for custom search.');
            isFetching = false;
            return [];
        }

        try {
            const url = window.location.origin + '/ghost/api/content/posts/?key=' + apiKey + '&limit=all&fields=title,url,published_at,custom_excerpt,excerpt';
            const res = await fetch(url);
            const data = await res.json();
            postsCache = data.posts || [];
            isFetching = false;
            return postsCache;
        } catch (err) {
            console.error('Error fetching posts for search:', err);
            isFetching = false;
            return [];
        }
    }

    function renderResults(posts, query) {
        if (query.trim() === '') {
            searchResults.style.display = 'none';
            searchResults.innerHTML = '';
            return;
        }
        
        const q = query.toLowerCase();
        const filtered = posts.filter(post => {
            return post.title.toLowerCase().includes(q) || 
                   (post.custom_excerpt && post.custom_excerpt.toLowerCase().includes(q)) || 
                   (post.excerpt && post.excerpt.toLowerCase().includes(q));
        }).slice(0, 5); // show top 5

        if (filtered.length === 0) {
            searchResults.innerHTML = '<div class="search-no-results">No results found</div>';
        } else {
            searchResults.innerHTML = filtered.map(post => `
                <a href="${post.url}" class="search-result-item">
                    <div class="search-result-title">${post.title}</div>
                    ${post.published_at ? `<div class="search-result-date">${new Date(post.published_at).toLocaleDateString()}</div>` : ''}
                </a>
            `).join('');
        }
        searchResults.style.display = 'block';
    }

    searchInput.addEventListener('input', async (e) => {
        const query = e.target.value;
        if (query.length > 0 && !postsCache) {
            await fetchPosts();
        }
        if (postsCache) {
            renderResults(postsCache, query);
        }
    });

    searchInput.addEventListener('focus', () => {
        if (searchInput.value.trim() !== '') {
            if (postsCache) {
                renderResults(postsCache, searchInput.value);
            }
        }
    });

    document.addEventListener('click', (e) => {
        if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
            searchResults.style.display = 'none';
        }
    });
})();
